import { create } from "zustand";
import { createAuthClient } from "better-auth/react";
import { organizationClient, jwtClient } from "better-auth/client/plugins"
import { ssoClient } from "@better-auth/sso/client"

export const useStoreAuth = create((set) => ({
  client: createAuthClient({
    baseURL: `${import.meta.env.VITE_WALLETTWO_URL}/auth/api/auth/`,
    plugins: [
      jwtClient(),
      organizationClient(),
      ssoClient()
    ],
  }),

  setClient: (client) => set({ client }),
  token: null,
  setToken: (token) => set({ token }),
}));
